




























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Store types
import { ToolProduct } from '@/store/store.types';

// Footer that holds the price, amount logic and action to add/remove
import ProductFooter from './ProductFooter.vue';

/**
 *  Component that renders a product tile, including his title,
 *  description and footer (component).
 */
@Component({
    components: {
        ProductFooter,
    },
})
export default class Product extends Vue {

    @Prop({ type: Object, required: true })
    private product!: ToolProduct;

}
